import { DateTime } from "luxon";
import { CONSUMPTION_STORAGE_TYPES } from "@shared/types/localTypes/usage-explorer.ts";
import { TourConsumptionRequest } from "@shared/types/localTypes/tour.ts";

type IsTourConsumptionRequest = (
  data: unknown,
) => data is TourConsumptionRequest;

type IsIsoDate = (value: unknown) => boolean;

const isIsoDate: IsIsoDate = (value) =>
  typeof value === "string" && DateTime.fromISO(value, { zone: "utc" }).isValid;

const isTourConsumptionRequest: IsTourConsumptionRequest = (
  data,
): data is TourConsumptionRequest => {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  if (!("nonce" in data) || typeof data.nonce !== "string") {
    return false;
  }
  if (!("start_date" in data) || !isIsoDate(data.start_date)) {
    return false;
  }
  if (!("end_date" in data) || !isIsoDate(data.end_date)) {
    return false;
  }
  return (
    "storage_type" in data &&
    CONSUMPTION_STORAGE_TYPES.some(
      (storageType) => storageType === data.storage_type,
    )
  );
};

export default isTourConsumptionRequest;
